import ReactOnRails from 'react-on-rails';

import NewsletterForm from './../../layout/components/newsletter/newsletter_form';
import MobileCategoriesSelect from './components/mobile_categories_select';
import LoggedInNotification from './../../layout/components/logged_in_notify';
import BlogMobileSearchForm from './components/blog_mobile_search';
import BlogOffersSearchForm from './components/blog_offers_search';
import BlogRelatedOffers from './components/blog_related_offers';
import Rating from '../../../javascript/common/components/hotel-rating';

ReactOnRails.register({
  NewsletterForm,
  MobileCategoriesSelect,
  LoggedInNotification,
  BlogMobileSearchForm,
  BlogOffersSearchForm,
  BlogRelatedOffers,
  Rating
});



// WEBPACK FOOTER //
// ./app/javascript/pages/blog/registration.jsx